import { Component, OnInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { BsDatepickerViewMode, BsDatepickerConfig } from 'ngx-bootstrap/datepicker/ngx-bootstrap-datepicker';
import { SWAlertService } from '../../services/swalert.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

import { DatePipe } from '@angular/common';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-exportto-sap',
  templateUrl: './exportto-sap.component.html',
  styleUrls: ['./exportto-sap.component.css']
})
export class ExporttoSAPComponent implements OnInit {
  modalRef: BsModalRef;
  constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router, private System: TSFuntionService, private SW: SWAlertService, private modalService: BsModalService, public datepipe: DatePipe) { }
  ExprottosapForm: FormGroup;
  iswait: boolean = true;
  arrCbExport: Array<any> = [];
  arrCbPaid: Array<any> = [];
  arrRequestID: Array<any> = [];
  //DatasRequestID: Array<any> = [];
  SumID: string;
  arrGL: any;
  arrFIDoc: any;
  arrMulti: any;
  lstData: any;
  isSupDoc: any;
  sSeeNote: any;
  sSearch: string = "";
  sDetailData = "";
  _ArrDataFirst = [];
  _ArrData = [];
  _ArrDataBind = [];
  //statuscheckbox: boolean = true;
  ResultPermission: boolean = true;
  isResult: boolean = false;
  isShowFIDoc: boolean = false;
  isShowClearingDoc: boolean = false;
  isShowAdvClearingDoc: boolean = false;
  isShowRecieveDoc: boolean = false;

  cAutoPost: string = 'N';

  public settings = {};
  public settings_com = {};
  ArrCompany = [];
  get _ExprottosapForm() { return this.ExprottosapForm.controls; }
  get SupDoc() { return this._ExprottosapForm.SupDoc as FormArray; }
  FilterGrid = {
    sSearch: "",
    nStatusID: [],
    nReqTypeID: [],
    sCompanyCode: []
  }
  async ngOnInit() {
    this.SetForm();
    this.settings = {
      singleSelection: false,
      idField: 'sValue',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    await this.loadStatus();
    this.ResultPermission = await this.System.CheckPermissionMeun(35); //F = ดู, T = แก้ 
    if (this.ResultPermission == false) {
      this.isResult = true;
    }
    else {
      this.isResult = false;
    }
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.cAutoPost = ua.cAutoPost;
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
    }

    this.Search();

    var cbHeader = <HTMLInputElement>document.getElementById("cbHeader");
    var cbColor = <HTMLInputElement>document.getElementById("cbColor");
    cbHeader.checked = true;
    cbColor.checked = true;

    this.arrCbExport = [];
    this._ArrDataFirst = [];
  }

  _Status = [];
  _RequestType = [];

  async loadStatus() {
    //Type
    let GetTaskType = await this.http.get<any>(this.System.SiteName + "api/Exporttosap/GetTaskType").toPromise();
    if (GetTaskType) {
      this._RequestType = GetTaskType;
    }
    //Status
    let GetStatus = await this.http.get<any>(this.System.SiteName + "api/Exporttosap/GetStatus").toPromise();
    if (GetStatus) {
      this._Status = GetStatus;
    }
    let GetCompany = await this.http.get<any>(this.System.SiteName + "api/Exporttosap/GetCompany").toPromise();
    if (GetCompany) {
      this.ArrCompany = GetCompany;
    }
  }

  //#region DataGrid
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }

  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";

  //#region 2. Header Colomn
  @Output() onChange = new EventEmitter();
  Columns = [
    { ColumnName: "Posted", SortField: "", Width: "5%" },
    { ColumnName: "Req. No.", SortField: "sRequestCode", Width: "8%" },
    { ColumnName: "Type", SortField: "sReqType", Width: "11%" },
    { ColumnName: "Vendor", SortField: "vendor", Width: "14%" },
    { ColumnName: "", SortField: "", Width: "3%" },
    { ColumnName: "Cost Center", SortField: "sCCTR", Width: "9%" },
    { ColumnName: "Net Total", SortField: "nTotalAmount", Width: "10%" },
    { ColumnName: "Due Date", SortField: "dDueDate", Width: "6%" },
    { ColumnName: "Note", SortField: "sDocHeader", Width: "7%" },
    { ColumnName: "FI Doc", SortField: "", Width: "5%" }
  ]
  //#endregion

  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize)
    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    let nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
    this.System.UnBlockUI();

    this.cbExportAll_Checked();
  }
  //#endregion

  cbExport(item, sRequestID) {
    //เก็บไว้ Save
    let DATA = this._ArrDataFirst.filter(f => f.sRequestID == sRequestID);
    if (DATA) {
      DATA[0].IsChecked = item.target.checked;
    }

    //แก้ไขข้อมูลผ่าน Array ที่ใช้แสดง Grid
    let DATA_TABLE = this._ArrDataBind.filter(f => f.sRequestID == sRequestID);
    if (DATA_TABLE) {
      DATA_TABLE[0].IsChecked = item.target.checked;
    }

    //แก้ไขข้อมูลผ่าน Array ที่มาจาก Database
    let DATA_BY_BASE = this._ArrData.filter(f => f.sRequestID == sRequestID);
    if (DATA_BY_BASE) {
      DATA_BY_BASE[0].IsChecked = item.target.checked;
    }

    this.cbExportAll_Checked();
  }

  cbExportAll(item) {
    let This = this;
    this._ArrDataBind.forEach(function (Item) {
      //เก็บไว้ Save
      let DATA = This._ArrDataFirst.filter(f => f.sRequestID == Item.sRequestID);
      if (DATA) {
        DATA[0].IsChecked = item.target.checked;
        var cbExport = <HTMLInputElement>document.getElementById("cbExport_" + Item.sRequestID);
        cbExport.checked = item.target.checked;
      }

      //แก้ไขข้อมูลผ่าน Array ที่ใช้แสดง Grid
      let DATA_TABLE = This._ArrDataBind.filter(f => f.sRequestID == Item.sRequestID);
      if (DATA_TABLE) {
        DATA_TABLE[0].IsChecked = item.target.checked;
      }

      //แก้ไขข้อมูลผ่าน Array ที่มาจาก Database
      let DATA_BY_BASE = This._ArrData.filter(f => f.sRequestID == Item.sRequestID);
      if (DATA_BY_BASE) {
        DATA_BY_BASE[0].IsChecked = item.target.checked;
      }
    })
  }

  cbExportAll_Checked() {
    if (this._ArrDataBind.length > 0) {
      let CheckITEM = this._ArrDataBind.length;
      let CheckData = this._ArrDataBind.filter(f => f.IsChecked == true).length;
      var cbExport_All = <HTMLInputElement>document.getElementById("cbExport_All");
      cbExport_All.checked = (CheckITEM == CheckData);
    }
  }

  Export(type) {
    let This = this;
    let CheckData = this._ArrDataFirst.filter(f => f.IsChecked == true);
    if (CheckData.length > 0) {
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, type === 1 ? This.SW.BoxMsg.Desc_Confirm_PostToSAP : This.SW.BoxMsg.Desc_Confirm_ExportToSAP, function () {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });

        let Dataexport = JSON.stringify(CheckData)
        This.http.post(This.System.SiteName + "api/Exporttosap/Save/" + type, Dataexport, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            This.SW.SwAlert.Success(This.SW.BoxMsg.Title_Success, type === 1 ? This.SW.BoxMsg.Desc_Success_PostToSAP : This.SW.BoxMsg.Desc_Success_ExportToSAP, function () {
              This.ExportUniversal(type);
             
            });
          }
          else {
            This.SW.SwAlert.Warning(This.SW.BoxMsg.Title_Warning, s, function () { });
          }
        })
      }, function () { });
    }
    else {
      this.SW.SwAlert.Warning(This.SW.BoxMsg.Title_Warning, This.SW.BoxMsg.Desc_CheckBox_Waring, function () { });
    }
  }

  async Search() {
    this._ArrDataFirst = [];
    this.System.BlockUI();
    let _this = this;
    let data: any;
    let ReqType: string = this.FilterGrid.nReqTypeID.length > 0 ? this.FilterGrid.nReqTypeID.map(e => e.sValue).join(",") : "";
    let Status: string = this.FilterGrid.nStatusID.length > 0 ? this.FilterGrid.nStatusID.map(e => e.sValue).join(",") : "";
    let sCompanyCode: string = this.FilterGrid.sCompanyCode.length > 0 ? this.FilterGrid.sCompanyCode.map(e => e.COMPANY_CODE).join(",") : "";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sSearch', this.FilterGrid.sSearch)
        .set('sStatus', Status)
        .set('sReqType', ReqType)
        .set('sCompanyCode', sCompanyCode)
    };
    await this.http.get<any>(this.System.SiteName + "api/Exporttosap/Search", httpOptions).toPromise().then(Data => {
      if (Data) {
        _this._ArrData = Data;
        if (_this._ArrDataFirst.length == 0) {
          _this._ArrData.forEach(function (item) {
            _this._ArrDataFirst.push({ sRequestID: item.sRequestID, IsChecked: false });
          })
        }

        //Update Check ให้กลับมา
        let DATA_CHECK = _this._ArrDataFirst.filter(f => f.IsChecked == true);
        DATA_CHECK.forEach(function (Item) {
          //แก้ไขข้อมูลผ่าน Array ที่มาจาก Database
          let DATA_BY_BASE = _this._ArrData.filter(f => f.sRequestID == Item.sRequestID);
          if (DATA_BY_BASE.length > 0) {
            DATA_BY_BASE[0].IsChecked = Item.IsChecked;
          }
        })
      }
      else {
        this._ArrData = [];
      }
      this.BindDataTable();
    });
  }
  async seeCCTR(template: TemplateRef<any>, sRequestID) {
    let cctrData = { sRequestID: sRequestID }
    let sendData = JSON.stringify(cctrData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/Exporttosap/GetsCCTR", sendData, { headers, responseType: 'text' }).toPromise().then(Data => data = Data)
      this.arrGL = JSON.parse(data);
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(template, config);
  }
  async seeFIDoc(template: TemplateRef<any>, sRequestID) {
    let cctrData = { sRequestID: sRequestID }
    let sendData = JSON.stringify(cctrData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/Exporttosap/GetFIDoc", sendData, { headers, responseType: 'text' }).toPromise().then(Data => data = Data)
      this.arrFIDoc = JSON.parse(data);
      if (this.arrFIDoc) {
        if (this.arrFIDoc.length > 0) {
          this.isShowFIDoc = this.arrFIDoc[0].nFIDoc > 0;
          this.isShowClearingDoc = this.arrFIDoc[0].nClearingDoc > 0;
          this.isShowAdvClearingDoc = this.arrFIDoc[0].nAdvClearingDoc > 0;
          this.isShowRecieveDoc = this.arrFIDoc[0].nRecieveDoc > 0;
        }
      }
    }
    const config: ModalOptions = { class: 'gray modal-xxl' };
    this.modalRef = this.modalService.show(template, config);
  }
  seeNote(Note: TemplateRef<any>, sRequestID) {
    let ITEM = this._ArrData.filter(f => f.sRequestID == sRequestID);
    if (ITEM.length > 0) {
      this.sSeeNote = ITEM[0].sNote;
    }
    else {
      this.sSeeNote = "-";
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(Note, config);
  }
  async seeItem(Multi: TemplateRef<any>, sRequestID) {
    let ItemData = { sRequestID: sRequestID }
    let sendData = JSON.stringify(ItemData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let dataMulti: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/Exporttosap/_GetItems", sendData, { headers, responseType: 'text' }).toPromise().then(Data => dataMulti = Data)
      this.arrMulti = JSON.parse(dataMulti);
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(Multi, config);
  }

  SetForm() {
    this.ExprottosapForm = this.formBuilder.group({
      SupDoc: new FormArray([
        new FormGroup({
          cbExport: new FormControl(''),
          nYear: new FormControl(''),
          sPaymentDoc: new FormControl(''),
          sSupportDoc: new FormControl('', Validators.required),
          sRequestID: new FormControl(''),
          sReqNo: new FormControl(''),
          sReqType: new FormControl(''),
          sVendor: new FormControl(''),
          sCCTR: new FormControl(''),
          nTotalAmount: new FormControl(''),
          dDueDate: new FormControl(''),
          sNote: new FormControl(''),
          IsStatus: new FormControl(''),
          IsReqUrgent: new FormControl(''),
          IsVendorGroup: new FormControl('')
        })
      ]),
    });
  }
  isFieldValidTbExprot(_Field: string, _inx) {
    let FromArray = this.ExprottosapForm.get('SupDoc') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssTbExprot(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidTbExprot(_Field, _inx),
      'has-feedback': this.isFieldValidTbExprot(_Field, _inx)
    };
  }

  onClick(value: string) {
    let _this = this;
    if (value == "Back") {
      this.router.navigate(["/admin-menu"]);
    }
  }
  onClear() {
    this.FilterGrid.nReqTypeID = [];
    this.FilterGrid.nStatusID = [];
    this.FilterGrid.sSearch = "";
    let ua = this.System.GetUserStorage();
    if (ua) {
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({ COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName })
      );
    }
    this.Search();
  }

  ExportUniversal(type) {

    var cbHeader = <HTMLInputElement>document.getElementById("cbHeader");
    var cbColor = <HTMLInputElement>document.getElementById("cbColor");
    this.System.BlockUI();

    let GetID = this._ArrDataFirst.filter(f => f.IsChecked == true);
    let ID = GetID.map(m => m.sRequestID).join(',');

    let _this = this;
    let _Data = {
      sMode: "",
      sRequestID: ID,
      IsHeader: cbHeader.checked,
      IsColor: cbColor.checked,
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    _this.http.post(_this.System.SiteName + "api/ExportUniversal/GenerateUniversal", JSON.stringify(_Data), { headers, responseType: 'arraybuffer' })
      .subscribe(res => {
        this.saveExcel(res, "Universal.xlsx", type);
      });
  }
  public saveExcel(result, fileName, type) {
    if (type === 2) {
      var blob = new Blob([result], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      if (window.navigator.msSaveOrOpenBlob) { // For IE:
        navigator.msSaveBlob(blob, fileName);
      } else { // For other browsers:
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    }
    this.Search();
    this.System.UnBlockUI();
  }

  async Gotopath(sRequestID) {
    let ID = await this.System.Encrypt(sRequestID);
    //await this.router.navigate(["/admin-adjust"], { queryParams: { str: ID } });
    let URL = "admin-adjust?str=" + ID;
    window.open(URL, '_blank');
  }
}
